import React, { Component } from 'react';

export default class MapControls extends Component {
    render() {
        return (
            <div
                style={{
                    zIndex: '10',
                    position: 'absolute',
                    bottom: '10px',
                    right: `${10 + this.props.offset}px`,
                    textAlign: 'center',
                    lineHeight: '0px',
                    boxShadow: '1px 1px 6px rgba(0,0,0,.3)',
                    fontSize: '1.6rem',
                    textAlign: 'center',
                    color: '#666',
                }}
            >
                <div
                    style={{
                        display: 'inline-block',
                        background: 'white',
                        borderRadius: '6px',
                        marginRight: '8px',
                    }}
                >
                    <div
                        className="round-btn"
                        style={{
                            cursor: 'pointer',
                            padding: '7px 6px 5px 6px',
                        }}
                        onClick={this.props.pan_to_full_map}
                    >
                        <i
                            class="bi bold bi-arrow-counterclockwise"
                            style={{ fontSize: '.8em' }}
                        ></i>
                    </div>
                </div>
                <div
                    style={{
                        display: 'inline-block',
                        background: 'white',
                        borderRadius: '6px',
                    }}
                >
                    <div>
                        <div
                            style={{
                                cursor: 'pointer',
                                padding: '4px',
                            }}
                            onClick={() =>
                                this.props.zoom_in(this.props.mouse_position)
                            }
                        >
                            <i class="bi bi-plus bold dark-hover"></i>
                        </div>
                    </div>
                    <div
                        style={{
                            margin: '0px 4px',
                            borderBottom: '2px solid #ccc',
                        }}
                    ></div>
                    <div>
                        <div
                            style={{
                                cursor: 'pointer',
                                padding: '4px',
                            }}
                            onClick={() =>
                                this.props.zoom_out(this.props.mouse_position)
                            }
                        >
                            <i class="bi bi-dash bold dark-hover"></i>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
